import { get, post } from '../request.js';

/**
 * 登录
 */
export async function doAccountLogin(params) {
  return post('/api/main/login', params);
}

/**
 * 登出
 */
export async function doAccountLogout(params) {
  return post('/api/main/logout', params);
}

/**
 * 用户信息
 */
export async function queryAccountInfo(params) {
  return get('/api/main/info', params);
}

/**
 * 菜单
 */
export async function queryMenu(params) {
  return get('/api/main/query_routers', params);
}

/**
 * 商户列表
 */
export async function queryAllBusiness(params) {
  return get('/api/asset/business/all', params);
}

/**
 * 大区+省市区
 */
export async function queryRegionTree(params) {
  return get('/api/system/regions/areas', params);
}

/**
 * 发送验证码
 */
export async function sendVerifyCode(params) {
  return post('/api/system/account/send_code', params);
}

/**
 * 获取验证图形
 */
export async function reqGet(params) {
  return post('/api/common/captcha/get', params);
}

/**
 * 验证图形滑块
 */
export async function reqCheck(params) {
  return post('/api/common/captcha/check', params);
}

/**
 * 申请试用
 */
export async function applyForTrial(params) {
  return post('/api/system/account/apply_trial', params);
}
